import { incidentDetailsCardPropertyDataGenerator } from '@/modules/adjusterReportModules/IncidentDetails/data/incidentDetailsCardPropertyDataGenerator.ts';
import useIncidentDetailsCauses from '@/modules/adjusterReportModules/IncidentDetails/hooks/incidentDetails/useIncidentDetailsCauses.ts';
import { getIncidentDetailCardInfo } from '@/modules/adjusterReportModules/IncidentDetails/queries/incidentDetails/property/getIncidentCardDetailsInfoProperty.ts';
import incidentDetailsMutationProperty from '@/modules/adjusterReportModules/IncidentDetails/queries/incidentDetails/property/incidentDetailsMutationProperty.ts';
import { IncidentDetailsMutationPropertyType } from '@/modules/adjusterReportModules/IncidentDetails/queries/incidentDetails/property/incidentDetailsMutationProperty.types.ts';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';

const useIncidentDetailsProperty = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { incidentCausePending, incidentCauseData, onIncidentDetailsChange } =
    useIncidentDetailsCauses(id!);

  const { data: incidentCardInfo, isPending: incidentCardInfoPending } =
    useQuery({
      queryKey: ['incidentDetailCard', id],
      queryFn: () => getIncidentDetailCardInfo({ id }),
      select: (data) => ({
        ...data,
        detailCardItems: incidentDetailsCardPropertyDataGenerator(data),
      }),
    });

  const { mutate: formMutate, isPending: mutatePending } = useMutation({
    mutationKey: ['incidentDetailMutation', id],
    mutationFn: (formData: Partial<IncidentDetailsMutationPropertyType>) =>
      incidentDetailsMutationProperty({ id, formData }),
    onSuccess: () => navigate(-1),
  });

  return {
    onIncidentDetailsChange,
    incidentCauseData,
    incidentCausePending,
    incidentCardInfo,
    incidentCardInfoPending,
    formMutate,
    mutatePending,
  };
};

export default useIncidentDetailsProperty;
